export const gradeTypeOption = [
    {
      value: 1,
      label: "小学"
    },
    {
      value: 2,
      label: "初中"
    },
    {
      value: 3,
      label: "高中"
    }
  ]